export const LOGIN_PAGE_PATHNAME = "/login";
export const MAIN_PAGE_PATHNAME = "/main";

// INFO: Адреса REST API Монолита
export const LOGIN_REQUEST_PATHNAME = "/login";
export const OTP_CHECK_REQUEST_PATHNAME = "/otp-check";
export const MONOLITH_LOGOUT_REQUEST_PATHNAME = "/auth/jwt-logout";
export const REFRESH_TOKEN_REQUEST_PATHNAME = "/auth/refresh-token";
export const USER_REQUEST_PATHNAME = "/users";
export const CLIENT_REQUEST_PATHNAME = "/clients/active";

// INFO: Адреса REST API МС Аутентификации
export const LOGIN_BY_PASSWORD_REQUEST_PATHNAME =
  "/api/authentication/external/v1/login-password";
export const LOGIN_BY_CHECK_SMS_CODE_PATHNAME =
  "/api/authentication/external/v1/login-by-sms-check-code";
export const LOGIN_BY_CERTIFICATE_PATHNAME =
  "/api/authentication/external/v1/login-by-certificate-check-random-string";
export const GET_ACCESS_BY_REFRESH_TOKEN_PATHNAME =
  "/api/authentication/external/v1/refresh/get-access-by-refresh";
export const MS_LOGOUT_REQUEST_PATHNAME =
  "/api/authentication/external/v1/refresh/logout";

// INFO: Query-параметры использующиеся для реализации сценариев SSO
export const QUERY_PARAM_PATH = "path";
export const QUERY_PARAM_CLIENT = "client";

export const NO_PERMISSIONS_ERROR =
  "Вы не можете выполнить вход в Систему. Ваши полномочия истекли";
